import styled from "styled-components";

export const Wrapper = styled.div`
  .uitility-col {
    display: flex;
    margin-top: 5px;
    p {
      margin: 0px;
    }
  }
`;
